import React from 'react';
import { ContentLoader } from '@rio-cloud/rio-uikit';
import { IDinamicSmartRoutePreferences } from 'src/components/Dynamics/DinamicSmartRoutePreferences';

interface LoadingSkeletonProps {
    smartRoutePreference: IDinamicSmartRoutePreferences;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ smartRoutePreference }) => {
    const activePreferences = Object.values(smartRoutePreference).filter(Boolean);
    const skeletonCount = activePreferences.length || 4;

    const renderSkeletonCard = (index: number, width = 'width-50pct') => (
        <div className={`display-inline-block ${width}`}>
            <div key={index} className="display-flex flex-column margin-5">
                <div className="bg-white rounded shadow-default padding-10 padding-top-0 display-flex flex-column gap-2">
                    <ContentLoader width="60%" className="height-20 margin-bottom-8" />
                    <ContentLoader width="40%" className="height-16" />
                </div>

                <div className="margin-top-20">
                    <div className="bg-white rounded shadow-default overflow-hidden">
                        <ContentLoader width="100%" className="height-300" />
                        <div className="padding-20">
                            <div className="margin-bottom-20">
                                <ContentLoader width="70%" className="height-16 margin-bottom-8" />
                                <ContentLoader width="60%" className="height-16" />
                            </div>
                            <ContentLoader width="100%" className="height-40" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="display-flex flex-column gap-10">
            <div>
                {renderSkeletonCard(1, 'width-100pct')}
            </div>
            <div className="display-block">
                {Array.from({ length: 4 }).map((_, index) => renderSkeletonCard(index))}
            </div>
            <div className="margin-top-20 display-flex justify-content-center">
                <ContentLoader width="200px" className="height-50" />
            </div>
        </div>
    );
};

export default LoadingSkeleton;